import http_request from './http_request'
import config from 'config'

function getSlide(flipgridUid) {
	return http_request.get(`${config.api}flipgrid/${flipgridUid}`)
		.withExternalJwt()
		.send()
}

function saveSlide(flipgridUid, teacherUrl, studentUrl) {
	return http_request.put(`${config.api}flipgrid/${flipgridUid}`)
		.withExternalJwt()
		.send({
			teacherUrl,
			studentUrl,
		})
}

export default {
	getSlide,
	saveSlide,
}
